/**
 * @method getPercentageAdjustment
 */
function getPercentageAdjustment(frame) {
  const activeContainer = frame.parentElement;
  const frameParent = activeContainer.parentElement;
  const parentScrollHeight = frameParent.scrollHeight;
  const parentOffsetHeight = frameParent.offsetHeight;
  const maxScrollTop = parentScrollHeight - parentOffsetHeight;
  const amountToScroll = parentOffsetHeight / 2;

  const percentageAdjustment = amountToScroll / maxScrollTop;

  return percentageAdjustment;
}

export default getPercentageAdjustment;
